import { taskFromRow } from '@/modules/tasks/row-mappers';
import type { Task } from '@/modules/tasks/types';

export function withInsertedTask(
  tasks: Task[],
  row: { id: string; team_id?: string | null },
  loadedTeamId: string | undefined,
): Task[] {
  if (loadedTeamId && row.team_id !== loadedTeamId) return tasks;
  if (tasks.some((task) => task.id === row.id)) return tasks;
  return [...tasks, taskFromRow(row)];
}
